import Navbar from './components/Navbar';
import Hero from './components/Hero';
import WhyUs from './components/WhyUs';
import SavingsSimulator from './components/SavingsSimulator';
import Catalog from './components/Catalog';
import CustomOrderCTA from './components/CustomOrderCTA';
import ImportProcess from './components/ImportProcess';
import FeaturedCars from './components/FeaturedCars';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';

export default function Home() {
  return (
    <main className="bg-[#050505] min-h-screen">
      <Navbar />
      <Hero />
      <WhyUs />
      <SavingsSimulator />
      <Catalog />
      <CustomOrderCTA />
      <ImportProcess />
      <FeaturedCars />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </main>
  );
}